import React from "react";
import './ContenidoInicio.css'
import ContenedorDesplegable from "./ContenedorDesplegable";
import ContenedorMateriasTeacher from "./ContenedorMateriasMaestro";
import Noticia from "./Noticia";
import imagen_capacitacion from '../Assets/capacitacion.png'
import imagen_taller from '../Assets/taller.png'
import imagen_comunicado from '../Assets/comunicado.png'
import ContenedorLinksZoom from "./ContenedorLinksZoom";
import ContenidoNoticias from "./ContenidoNoticias"; // <--- IMPORTANTE


const ContenidoInicioT = ({ redireccionC, a_titulo, a_contenido, b_titulo, b_contenido}) => {
    return (
        <div className="contenido-inicio">
            <div className="contenedor-izquierdo">
                <ContenedorDesplegable titulo={a_titulo} contenido={a_contenido} />
                <ContenedorDesplegable titulo={'Mis Cursos'} contenido={<ContenedorMateriasTeacher redireccionB={redireccionC} />} />
                <ContenedorDesplegable titulo={b_titulo} contenido={b_contenido} />
            </div>
            <div className="contenedor-derecho">
            <ContenedorDesplegable 
  titulo={'Noticias'}
  contenido={<ContenidoNoticias />}
/>
            </div>
        </div>
    )
}

export default ContenidoInicioT